import React, { useMemo } from 'react'
import { cn } from '@utils/safeTs'
import styles from './MyAccountPersonalizzazioneHead.module.sass'
import { OrdineDetailType, PersonalizzazioneOrdineType, UserType } from '@utils/types'
import { StatoOrdine } from '@components/atoms'
import useTrans from '@hooks/useTrans'
import { ChevronDown } from '@components/icons'
import { getStatoPersonalizzazione } from '@utils/gestione/utils'
import { StatoOrdineStatusPosizioneToOrdineMap } from '@components/atoms/StatoOrdine/StatoOrdine'


interface Props {
  ordine: OrdineDetailType
  personalizzazione: PersonalizzazioneOrdineType
  variant?: 'default' | 'accordion'
  open?: boolean
  setOpen?: (v: boolean) => void
  id?: string
  contentId?: string
  userType?: UserType
  className?: string
}

const MyAccountPersonalizzazioneHead = (props: Props) => {

  const { 
    id, // obbligatorio solo se accordion
    contentId, // considerato solo se accordion
    ordine, 
    personalizzazione,
    variant = 'default',
    open = false,
    setOpen,
    userType,
    className = '',
  } = props

  const t = useTrans()
  const statoPersonalizzazione = useMemo(() => getStatoPersonalizzazione(personalizzazione, ordine), [personalizzazione])
  const details = [
    { label: t("N. Documento:"), value: `${ordine?.numeroDocumento}${userType !== 'cliente' && ordine?.ordineFornitore ? ` (${ordine.ordineFornitore.numeroDocumento})` : ''}` || '-' },
    { label: t("Personalizzazione:"), value: personalizzazione.nomeLavorazione || '-' },
    !['fornitore', 'cliente'].includes(userType) ? { label: t("Fornitore:"), value: ordine?.fornitore?.ragioneSociale || '-' || '-' } : {},
  ]

  const getContent = () => (
    <>
      <h2 className={styles.details}>
        {details.map(d => (
          <span className={styles.detail} key={d.label}>
            <span className={styles.detailLabel}>{d.label}{' '}</span>
            <span className={styles.detailValue}>{d.value}</span>
          </span>
        ))}
      </h2>
      {statoPersonalizzazione ? (
        <StatoOrdine
          stato={statoPersonalizzazione}
          level={'personalizzazione'}
          userType={userType}
        />
      ) : null}
    </>
  )

  return variant === 'accordion' ? (
    <button 
      className={cn(styles.root, styles[`root--${userType}`], open ? styles[`root--open`] : '', className)} 
      onClick={() => setOpen(!open)}
      aria-expanded={open ? 'true' : 'false'}
      aria-controls={contentId}
      id={id}
    >
      {getContent()}
      <span className={styles.arrow}>
        <ChevronDown />
      </span>
    </button>
  ) : (
    <header className={cn(styles.root, styles[`root--${userType}`], className)} id={id}>
      {getContent()}
    </header>
  )
}

export default MyAccountPersonalizzazioneHead
